// @flow
import { defineStore } from 'pinia'

export const useEntityContextStore = defineStore('entityContext', {
  state: (): EntityContextState => ({
    // model data, generic to be re-usable
    // type: workout, customWorkout, plan, category, etc
    entity: Laravel && Laravel.entity ? Laravel.entity : {},
    context: Laravel && Laravel.context ? Laravel.context : {},
  }),

  getters: {},

  actions: {},
})
